import angular from 'angular';
import translate from 'angular-translate';
import router from '@uirouter/angularjs';
import 'angular-uuid';
import { each } from 'underscore';
import '@nsoft/seven-ng-client-core/src/seven/sevenServices';
import '@nsoft/seven-ng-socket/dist/nab-ng-socket';
import '@nsoft/seven-ng-client-core/dist/seven-ng-client-core';
import '@nsoft/seven-ng-lib/dist/seven-ng-lib';
import commonModule from '../common';
import modulesModule from '../modules';
import userModule from '../user';
import sevenMoneyOverride from './filters/sevenMoneyOverrideFilter';
import CloudflareService from './services/cloudflareService';
import CmsFormsParserService from './services/cmsFormsParserService';
import GravityFormsProvider from './gravity/gravityFormsProvider';
import GravityLayoutsProvider from './gravity/gravityLayoutsProvider';
import GravitySettingsProvider from './gravity/gravitySettingsProvider';
import sGravityControlComponent from './components/sGravityControlComponent';
import errorParser from './services/errorParser';

import sEquals from './directives/sEqualsDirective';
import sKeyEvents from './keyEvents/keyEventsDirective';
import KeyEventsSvc from './keyEvents/keyEventService';

(function () {
  /**
   * @module "7Shop.Core"
   */
  angular.module('7Shop.Core', [
    translate,
    router,
    'ngLib',
    'SevenClientCore',
    'SevenClient.Config',
    commonModule,
    modulesModule,
    userModule
  ]).run(function (
    $rootScope,
    Shortcuts
  ) {
    /**
       *
       * @param e
       * @param eventData
       * @param eventData.productId
       * @param eventData.data
       * @param eventData.data.shortcuts
       * @param eventData.data.color
       * @param eventData.data.ticketCheckFormatter
       */
    function registerShortcuts(e, eventData) {
      if (eventData.data.shortcuts) {
        each(eventData.data.shortcuts, function (shortcut) {
          if (!shortcut.category) {
            shortcut.category = eventData.productId;
          }
          Shortcuts.registerShortcuts([shortcut]);
        });
      }
    }
    /**
     *
     */
    $rootScope.$on(
      '7S:Widget.UpdateProductSettings', registerShortcuts
    );
    /**
     *
     */
    $rootScope.$on(
      '7S:Widget.UpdateSettings', registerShortcuts
    );
  }).factory('KeyEventsSvc', KeyEventsSvc)
    .filter('sevenMoneyOverride', sevenMoneyOverride)
    .service('CloudflareService', CloudflareService)
    .service('CmsFormsParserService', CmsFormsParserService)
    .service('errorParser', errorParser)
    .provider('GravityForms', GravityFormsProvider)
    .provider('GravityLayouts', GravityLayoutsProvider)
    .provider('GravitySettings', GravitySettingsProvider)
    .directive('sEquals', sEquals)
    .directive('sKeyEvents', sKeyEvents)
    .component('sGravityControl', sGravityControlComponent);
})();
